import { version, install } from './index'
import './index.styl'

export { version, install }